import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import EmpLayout from "./emp_layout";
// import './emp_messages.css';


const empMsgCss = `
  .emsg-layout { display:grid; grid-template-columns:300px 1fr; gap:0; height:calc(100vh - 130px); background:#fff; border:1px solid rgba(26,26,26,0.07); border-radius:4px; overflow:hidden; }
  .emsg-list { border-right:1px solid rgba(26,26,26,0.07); overflow-y:auto; }
  .emsg-list-hdr { padding:1.1rem 1.25rem; border-bottom:1px solid rgba(26,26,26,0.07); font-family:'Cormorant Garamond',serif; font-size:1rem; font-weight:600; color:#1a1a1a; }
  .emsg-list-hdr em { font-style:italic; }
  .emsg-item { padding:1rem 1.25rem; border-bottom:1px solid rgba(26,26,26,0.05); cursor:pointer; transition:background 0.15s; display:flex; gap:0.75rem; }
  .emsg-item:hover { background:#faf8f5; }
  .emsg-item.active { background:#f5f0e8; }
  .emsg-av { width:38px; height:38px; border-radius:50%; background:#f5f0e8; border:1px solid rgba(26,26,26,0.08); display:flex; align-items:center; justify-content:center; font-family:'Cormorant Garamond',serif; font-size:0.9rem; font-weight:600; color:#888; flex-shrink:0; }
  .emsg-body { flex:1; min-width:0; }
  .emsg-top { display:flex; justify-content:space-between; align-items:baseline; margin-bottom:2px; }
  .emsg-name { font-size:0.84rem; font-weight:500; color:#1a1a1a; }
  .emsg-time { font-size:0.65rem; color:#bbb; flex-shrink:0; }
  .emsg-preview { font-size:0.75rem; color:#aaa; font-weight:300; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .emsg-preview.unread { color:#555; font-weight:400; }
  .emsg-role { font-size:0.65rem; color:#c9a84c; margin-bottom:1px; }
  .emsg-unread-dot { width:7px; height:7px; border-radius:50%; background:#c9a84c; flex-shrink:0; margin-top:6px; }
  .emsg-thread { display:flex; flex-direction:column; overflow:hidden; }
  .emsg-thread-hdr { padding:1.1rem 1.5rem; border-bottom:1px solid rgba(26,26,26,0.07); display:flex; align-items:center; gap:0.75rem; }
  .emsg-thread-av { width:36px; height:36px; border-radius:50%; background:#f5f0e8; border:1px solid rgba(26,26,26,0.08); display:flex; align-items:center; justify-content:center; font-family:'Cormorant Garamond',serif; font-size:0.85rem; font-weight:600; color:#888; }
  .emsg-thread-name { font-size:0.9rem; font-weight:500; color:#1a1a1a; }
  .emsg-thread-role { font-size:0.72rem; color:#aaa; }
  .emsg-view-profile { margin-left:auto; font-size:0.68rem; color:#c9a84c; text-decoration:none; border:1px solid rgba(201,168,76,0.3); padding:4px 10px; border-radius:2px; transition:all 0.2s; }
  .emsg-view-profile:hover { background:rgba(201,168,76,0.08); }
  .emsg-thread-body { flex:1; overflow-y:auto; padding:1.25rem 1.5rem; display:flex; flex-direction:column; gap:1rem; }
  .emsg-bubble { max-width:72%; }
  .emsg-bubble.mine { align-self:flex-end; }
  .emsg-bubble.theirs { align-self:flex-start; }
  .emsg-bubble-text { padding:0.75rem 1rem; border-radius:4px; font-size:0.84rem; line-height:1.6; }
  .emsg-bubble.mine .emsg-bubble-text { background:#1a1a1a; color:#f5f0e8; border-radius:4px 4px 0 4px; }
  .emsg-bubble.theirs .emsg-bubble-text { background:#f5f0e8; color:#1a1a1a; border-radius:4px 4px 4px 0; }
  .emsg-bubble-time { font-size:0.62rem; color:#bbb; margin-top:3px; }
  .emsg-bubble.mine .emsg-bubble-time { text-align:right; }
  .emsg-compose { padding:1rem 1.5rem; border-top:1px solid rgba(26,26,26,0.07); display:flex; gap:0.75rem; }
  .emsg-compose-input { flex:1; padding:0.75rem 1rem; background:#f5f0e8; border:1px solid rgba(26,26,26,0.1); border-radius:2px; font-family:'DM Sans',sans-serif; font-size:0.85rem; font-weight:300; color:#1a1a1a; outline:none; resize:none; transition:border-color 0.2s; }
  .emsg-compose-input:focus { border-color:#c9a84c; }
  .emsg-send-btn { background:#1a1a1a; color:#f5f0e8; padding:0.75rem 1.25rem; border:none; border-radius:2px; font-family:'DM Sans',sans-serif; font-size:0.72rem; font-weight:500; letter-spacing:0.08em; text-transform:uppercase; cursor:pointer; transition:background 0.2s; flex-shrink:0; }
  .emsg-send-btn:hover { background:#c9a84c; color:#1a1a1a; }
  @media(max-width:768px){
    .emsg-layout { grid-template-columns:1fr; height:auto; }
    .emsg-thread { display:none; }
    .emsg-layout.thread-open .emsg-list { display:none; }
    .emsg-layout.thread-open .emsg-thread { display:flex; height:calc(100vh - 140px); }
  }
`;

const EMP_CONVOS = [
  { id:1, initials:"AO", name:"Amara Osei", role:"Applied: Senior Hair Stylist", time:"10:32 AM", unread:true, preview:"Thank you! I'll be there on the 28th.",
    messages:[
      { mine:true,  text:"Hi Amara! We've reviewed your application and would love to invite you for an interview.", time:"Yesterday 3:00 PM" },
      { mine:false, text:"Thank you so much! I'm very excited about the opportunity.", time:"Yesterday 3:20 PM" },
      { mine:true,  text:"How does Thursday the 28th at 10:00 AM on Google Meet sound?", time:"Yesterday 3:35 PM" },
      { mine:false, text:"That works perfectly for me. Looking forward to it!", time:"Yesterday 3:50 PM" },
      { mine:false, text:"Thank you! I'll be there on the 28th.", time:"10:32 AM" },
    ]
  },
  { id:2, initials:"BN", name:"Brenda Njoroge", role:"Applied: Lead Esthetician", time:"Yesterday", unread:true, preview:"Could you tell me more about the benefits?",
    messages:[
      { mine:false, text:"Hello! I'm very interested in the Lead Esthetician role. Could you tell me more about the benefits package?", time:"Yesterday 2:00 PM" },
    ]
  },
  { id:3, initials:"FM", name:"Fatima Mwenda", role:"Applied: Senior Hair Stylist", time:"Mar 20", unread:false, preview:"I understand, thank you for letting me know.",
    messages:[
      { mine:true, text:"Hi Fatima, thanks for applying. We'll be in touch with next steps soon.", time:"Mar 20 11:00 AM" },
      { mine:false, text:"I understand, thank you for letting me know.", time:"Mar 20 11:30 AM" },
    ]
  },
];

export function EmpMessages() {
  const navigate = useNavigate();
  const [active, setActive] = useState(1);
  const [text, setText] = useState("");
  const [convos, setConvos] = useState(EMP_CONVOS);
  const [mobileThread, setMobileThread] = useState(false);
  const activeConvo = convos.find(c => c.id === active);
  const sendMessage = () => {
    if (!text.trim()) return;
    setConvos(prev => prev.map(c => c.id === active ? { ...c, messages:[...c.messages,{mine:true,text,time:"Just now"}], preview:text, unread:false } : c));
    setText("");
  };

  return (
    <EmpLayout title="My" titleEm="Messages">
      <div className={`emsg-layout${mobileThread?" thread-open":""}`}>
        <div className="emsg-list">
          <div className="emsg-list-hdr">Messages <em>({convos.filter(c=>c.unread).length} unread)</em></div>
          {convos.map(c => (
            <div key={c.id} className={`emsg-item${active===c.id?" active":""}`}
              onClick={() => { setActive(c.id); setMobileThread(true); setConvos(prev=>prev.map(x=>x.id===c.id?{...x,unread:false}:x)); }}>
              <div className="emsg-av">{c.initials}</div>
              <div className="emsg-body">
                <div className="emsg-top"><div className="emsg-name">{c.name}</div><div className="emsg-time">{c.time}</div></div>
                <div className="emsg-role">{c.role}</div>
                <div className={`emsg-preview${c.unread?" unread":""}`}>{c.preview}</div>
              </div>
              {c.unread && <div className="emsg-unread-dot" />}
            </div>
          ))}
        </div>
        <div className="emsg-thread">
          {activeConvo && (<>
            <div className="emsg-thread-hdr">
              <div className="emsg-thread-av">{activeConvo.initials}</div>
              <div>
                <div className="emsg-thread-name">{activeConvo.name}</div>
                <div className="emsg-thread-role">{activeConvo.role}</div>
              </div>
              <Link to="/employer/candidate/1" className="emsg-view-profile">View Profile →</Link>
            </div>
            <div className="emsg-thread-body">
              {activeConvo.messages.map((m,i)=>(
                <div key={i} className={`emsg-bubble ${m.mine?"mine":"theirs"}`}>
                  <div className="emsg-bubble-text">{m.text}</div>
                  <div className="emsg-bubble-time">{m.time}</div>
                </div>
              ))}
            </div>
            <div className="emsg-compose">
              <textarea className="emsg-compose-input" rows={1} placeholder="Type a message…" value={text} onChange={e=>setText(e.target.value)}
                onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();sendMessage();}}} />
              <button className="emsg-send-btn" onClick={sendMessage}>Send</button>
            </div>
          </>)}
        </div>
      </div>
    </EmpLayout>
  );
}